<template>
  <v-footer class="py-3 mt-6 position-relative d-none d-md-block">
    <div class="container-fluid">
      <div
        v-if="authUser && authUser.is_student"
        class="row"
      >
        <div class="col-md-4" />
        <div class="col-md-4 align-self-center">
          <p class="text-center text-decoration-none font-weight-500 m-0">
            Evolucional @ 2022 <br>
            Todos os direitos reservados
          </p>
        </div>
        <div class="col d-flex align-items-center justify-content-center">
          <img
            src="/images/logo_nitro_gray.svg"
            style="width: 160px; height: 73px;"
            alt="Nitro Logo Rodapé"
          >
        </div>
      </div>
      <div
        v-else
        class="row"
      >
        <div class="col-md-4">
          <h4 class="font-weight-bolder text-black-90">
            Suporte
          </h4>
          <nav class="d-flex flex-column">
            <a
              href="mailto:suporte@evolucional.com.br"
              class="text-decoration-none font-weight-500"
            >
              Email:suporte@evolucional.com.br
            </a>
          </nav>
        </div>
        <div class="col-md-4">
          <p class="text-center text-decoration-none font-weight-500">
            Evolucional @ 2022 <br>
            Todos os direitos reservados
          </p>
        </div>
        <div class="col d-flex align-items-center justify-content-end">
          <img
            src="/images/logo_nitro_gray.svg"
            style="width: 160px; height: 73px;"
            alt="Nitro Logo Rodapé"
          >
        </div>
      </div>
    </div>
  </v-footer>
</template>
<script>

export default {
  computed:{
    authUser(){
      return this.$store.state.auth.user;
    }
  }
}
</script>

